export default "__VITE_ASSET__np9wgbjl__"